import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'redux/selectors';

export const useHasOutlookSyncFeature = ({ network } = {}) => {
  const user = useSelector(userSelector);

  return useMemo(() => {
    if (network) {
      return network.features?.includes('outlook_sync') ?? false;
    }

    const hasInManaging = user.managingCollections?.some((n) => n.features?.includes('outlook_sync')) ?? false;
    const hasInAllying = user.allyingCollections?.some((n) => n.features?.includes('outlook_sync')) ?? false;

    return hasInManaging || hasInAllying;
  }, [network, user.managingCollections, user.allyingCollections]);
};
